<template>
    <v-container>
        <v-flex>
            <v-layout row class="my-2">
                <h2>{{txc.pageTitle}}</h2>
            </v-layout>
            <template>
                <ns-address-manager  @state="showProcessing" />
                <loader v-show="processing" />
            </template>
        </v-flex>
    </v-container>
</template>

<script>
import { NsAddressManager } from '@nuskin/app-elements';
import { mapGetters } from 'vuex';
import Loader from '../components/Loader';

export default {
    name: 'AddressSection',
    data() {
        return {
            processing: false
        };
    },
    components: { NsAddressManager, Loader },
    computed: {
        ...mapGetters({
            fullscreen: 'mobileView',
            txc: 'translationsAddress',
            siteConfig: 'siteConfig'
        })
    },
    methods: {
        showProcessing(val) {
            let isBusy = false;
            if (val === 'busy') {
                isBusy = true;
            }

            this.processing = isBusy;
        }
    }
}
</script>